import type { QueryClient } from '@tanstack/react-query';

// A mutation invalidates the list and the detail of its resource (UI architecture §4). The two keys
// share no prefix, so both are named: ['get', path] and ['get', `${path}/{id}`] for that id, or for
// every id without one.
export async function invalidateResource(
  queryClient: QueryClient,
  path: string,
  id?: string,
): Promise<void> {
  const detailInit = id === undefined ? [] : [{ params: { path: { id } } }];
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['get', path] }),
    queryClient.invalidateQueries({ queryKey: ['get', `${path}/{id}`, ...detailInit] }),
  ]);
}
